module.exports = __webpack_public_path__ + "img/horizontal_6_7_3.6281ac7f.png";